<template lang="pug">
v-list-item-group
  v-list-item(link)
    template(#default="{ active, toggle }")
      v-list-item-action.mr-2
        v-checkbox(
          v-model="active"
          @input="toggle"
          @change="emitAnswer"
        )
      v-list-item-content Прочитал(а)
  //- v-card-text

  //-   v-checkbox(v-model="answer" class="reading-mark" @change="emitAnswer" label="Прочитал(а)")

</template>

<script>
export default {
  name: 'TypeMark',
  data: () => ({
    answer: false,
  }),
  mounted() {
    this.emitAnswer();
  },
  methods: {
    emitAnswer() {
      this.$emit('answer', {
        fieldName: 'mark_reading',
        answer: this.answer,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
